import React, { useState, useEffect } from 'react';
import Plyr from 'plyr-react';
import { useParams, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

function Xvid() {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(true);
  const [isAdult, setIsAdult] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = () => {
    setIsAdult(true);
    setShowModal(false);
  };

  const handleCancel = () => {
    navigate('/');
  };

  return (
    <>
      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header>
          <Modal.Title>18+ Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You must confirm that you are 18 years old or older to continue watching.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            I am 18 or older
          </Button>
        </Modal.Footer>
      </Modal>

      {isAdult && (
         <div>
           <Plyr
           key={id}
            source={{
            type: 'video',
             sources: [
              {
                src: `/video/${id}`,
                type: 'video/mp4',
            },
           ],
           }}
           />
        </div>
      )}
    </>
  );
}

export default Xvid;
